import clsx from 'clsx';
import type { FormLocale } from '@jlg-website/shared';
import { formatDayLabel } from '../shared/date-time';
import type { CalendarDay } from './type';

type CalendarDayItemProps = {
  day: CalendarDay;
  selected: boolean;
  locale: FormLocale;
  onSelect: (date: string) => void;
};

export function CalendarDayItem({ day, selected, locale, onSelect }: CalendarDayItemProps) {
  if (!day.selectable) {
    return (
      <span
        className="flex h-10 items-center justify-center text-sm text-gray-light"
        aria-disabled="true"
      >
        {day.dayOfMonth}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={() => onSelect(day.date)}
      aria-pressed={selected}
      // The visible number is all a screen reader would otherwise announce, with no month.
      aria-label={formatDayLabel(locale, day.date)}
      className={clsx(
        'flex h-10 cursor-pointer items-center justify-center rounded-md text-sm font-medium transition-colors duration-200',
        selected
          ? 'bg-brand-primary text-white'
          : 'bg-brand-accent/10 text-brand-primary hover:bg-brand-accent/20'
      )}
    >
      {day.dayOfMonth}
    </button>
  );
}
